import React, { useState } from 'react';
import Footer from '../components/Footer';
import siteData from '../data/site.json';
import { SiInstagram, SiLinkedin, SiThreads, SiGithub } from 'react-icons/si';

const socialIcons = {
  Instagram: SiInstagram,
  LinkedIn: SiLinkedin,
  Threads: SiThreads,
  Github: SiGithub,
};

const Contact = () => {
  const [status, setStatus] = useState('idle'); // idle, submitting, success, error

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');

    const form = e.target;
    const data = new FormData(form);

    try {
      const response = await fetch('https://formspree.io/f/xpqlveol', {
        method: 'POST',
        body: data,
        headers: {
          Accept: 'application/json',
        },
      });

      if (response.ok) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <main className="main-wrapper">
      <div className="main-wrapper-left">
        <div className="contact-hero-image-wrapper">
          <div className="card-corner-bottom-right">
            <div className="text-meta">Contact</div>
            <div className="corner-bottom-right top w-embed">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
              </svg>
            </div>
            <div className="corner-bottom-right bottom w-embed">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
              </svg>
            </div>
          </div>
          <img src="/images/jojo.webp" alt="Contact" loading="lazy" className="contact-hero-image" />
        </div>
      </div>
      <div className="main-wrapper-right remove-padding remove-grid">
        <div className="contact-right-inner">
          <section className="contact-top">
            <h1 className="heading-style-h1">Let's Talk</h1>
            <div className="form-wrapper">
              {status === 'success' ? (
                <div className="form-success">
                  <div className="heading-style-h3">Thank you!</div>
                  <p>Your message has been sent. I'll get back to you soon.</p>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-field-wrapper">
                    <div className="form-grid-1-2">
                      <input className="form-input w-input" maxLength="256" name="name" placeholder="Your Name" type="text" required disabled={status === 'submitting'} />
                      <input className="form-input w-input" maxLength="256" name="email" placeholder="Your Email" type="email" required disabled={status === 'submitting'} />
                    </div>
                  </div>
                  <div className="form-field-wrapper">
                    <textarea className="form-input is-text-area w-input" name="message" maxLength="5000" placeholder="Your Message" required disabled={status === 'submitting'}></textarea>
                  </div>
                  {status === 'error' && (
                    <div className="form-error">
                      Something went wrong. Please try again or email me directly.
                    </div>
                  )}
                  <button type="submit" className="button primary w-button" disabled={status === 'submitting'}>
                    {status === 'submitting' ? 'Sending...' : 'Send Message'}
                  </button>
                </form>
              )}
            </div>
          </section>

          <section className="contact-bottom">
            <div className="contact-bottom-left">
              <h1 className="heading-style-h5">
                MCR + LDN
              </h1>
              <img src="/images/map.svg" alt="MCR + LDN location map" />
              <div className="contact-bottom-left-grid">
              </div>
            </div>
            <div className="image-wrapper">
              <img loading="lazy" src="/images/jo-outside.webp" alt="Studio" className="image-cover" />
            </div>
            <div className="contact-bottom-socials">
              {siteData.socials.map((social) => {
                const IconComponent = socialIcons[social.label];
                return (
                  <a key={`contact-${social.label}`} href={social.url} target="_blank" rel="noreferrer" className="social-card w-inline-block">
                    <div>{social.label}</div>
                    <div className="social-card-icon-wrapper">
                      <div className="social-card-icon w-embed">
                        {IconComponent ? <IconComponent /> : null}
                      </div>
                      <div className="social-card-icon-hover w-embed">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
                          <path d="M198,64V168a6,6,0,0,1-12,0V78.48L68.24,196.24a6,6,0,0,1-8.48-8.48L177.52,70H88a6,6,0,0,1,0-12H192A6,6,0,0,1,198,64Z"></path>
                        </svg>
                      </div>
                    </div>
                  </a>
                );
              })}
              <a href="mailto:hello@example.com" className="social-card primary w-inline-block">
                <div className="text-meta text-color-inverse">Email Me</div>
                <div className="social-card-icon-wrapper">
                  <div className="social-card-icon w-embed">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
                      <path d="M224,50H32a6,6,0,0,0-6,6V192a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A6,6,0,0,0,224,50Zm-96,85.86L47.42,62H208.58ZM101.67,128,38,186.36V69.64Zm8.88,8.14L124,148.42a6,6,0,0,0,8.1,0l13.4-12.28L208.58,194H47.43ZM154.33,128,218,69.64V186.36Z"></path>
                    </svg>
                  </div>
                  <div className="social-card-icon-hover w-embed">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
                      <path d="M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z"></path>
                    </svg>
                  </div>
                </div>
              </a>
            </div>
          </section>
        </div>
        <Footer />
      </div>
    </main>
  );
};

export default Contact;

